import React from "react";
import { useMutation } from "@apollo/client";
import mutations from "Shared/mutations";
import pretty from "Shared/pretty";
import { errorToast, successToast } from "Modules/DPToast";
import { downloadS3File } from "Modules/S3Downloads";
import {
  GeneratePartnerReportMutation,
  GeneratePartnerReportMutationVariables,
  CreatePartnerReportMutation,
  CreatePartnerReportMutationVariables,
  PartnerReport,
} from "generated/graphql";
import { AmplitudeProvider } from "Shared/Analytics/Amplitude";
import { AmplitudeEventType } from "Shared/Analytics/Amplitude/Types/AmplitudeEventType";
import { DPTable } from "Components/DP";
import { Header } from "Components/DP/DPTable/DPTable";
import ReportTableRow from "./ReportTableRow/ReportTableRow";
import reportList from "../reportList";

const HEADERS: Header[] = ["Report", "Description", "Request"];

export const ReportsTable = () => {
  const [generateReportUrl] = useMutation<
    GeneratePartnerReportMutation,
    GeneratePartnerReportMutationVariables
  >(mutations.GENERATE_PARTNER_REPORT);

  const [createReportFn] = useMutation<
    CreatePartnerReportMutation,
    CreatePartnerReportMutationVariables
  >(mutations.CREATE_PARTNER_REPORT);

  const onDownloadClick = async (reportType: PartnerReport, reportName: string) => {
    AmplitudeProvider.logEvent({
      type: AmplitudeEventType.ReportExportClicked,
      payload: { tab: reportName }
    });

    try {
      const { data } = await generateReportUrl({ variables: { reportType: reportType }});

      downloadS3File(data!.generatePartnerReportUrl.reportUrl);
    } catch (err) {
      errorToast("Something went wrong. Please, try again later.");
    }
  };

  const reportExportHandler = async (reportType: PartnerReport, reportName: string) => {
    AmplitudeProvider.logEvent({
      type: AmplitudeEventType.ReportExportClicked,
      payload: { tab: reportName },
    });

    await createReportFn({
      variables: {
        reportType: reportType,
      },
    });
    const reportText = pretty.titleizeWord(reportType);
    successToast(
      `We’re emailing you the ${reportText} Report. Check your inbox in a few minutes.`
    );
  };


  return (
    <DPTable headers={HEADERS}>
      {reportList.map((report) => (
        <ReportTableRow
          key={report.name}
          onDownloadClick={() => onDownloadClick(report.type, report.name)}
          handleExport={() => {
            reportExportHandler(report.type, report.name);
          }}
          {...report}
        />
      ))}
    </DPTable>
  );
};
